import { render, staticRenderFns } from "./FormUpdatePassword.vue?vue&type=template&id=54350418"
import script from "./FormUpdatePassword.vue?vue&type=script&lang=js"
export * from "./FormUpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports